define('CustomMyAccountData.Second.EntryPoint', [
  'Utils',
  'Consolidated.History.View',
  'CustomMyAccountData.SuiteScript2.Model',
  'Profile.Model'
], function (
  Utils,
  ConsolidatedHistoryView,
  CustomMyAccountDataSuiteScript2Model,
  ProfileModel
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent('Layout');
      var pageType = container.getComponent('PageType');
      var myaccountmenu = container.getComponent('MyAccountMenu');
      var model = new CustomMyAccountDataSuiteScript2Model();
      var consolidatedHistory = {};
      var consolidatedReturns = {};
      var customerIsAggregated = false;
      var contactIsAggregated = false;

      pageType.registerPageType({
        'name': 'ConsolidatedHistory',
        'routes': ['consolidated'],
        'view': ConsolidatedHistoryView
      });

      pageType.registerPageType({
        'name': 'ConsolidatedReturns',
        'routes': ['consolidated-returns'],
        'options': {
          'trantype': 'consolidatedreturns',
          'selected': 'consolidatedreturns',
          'url': 'consolidated-returns',
          'title': Utils.translate('Aggregated Returns History')
        },
        'view': ConsolidatedHistoryView
      });

      layout.on('beforeShowContent', function () {
        var promise = jQuery.Deferred();
        if (ProfileModel.getInstance().get('isLoggedIn') !== 'T') {
          promise.resolve();
          return promise;
        }
        model.fetch({}).done(function (response) {
          if (response && response.success) {
            customerIsAggregated = Boolean(response.value.length > 0 && response.value[0].customerIsAggregated === 'T');
            contactIsAggregated = Boolean(response.value.length > 0 && response.value[1].contactIsAggregate === 'T');

            if (customerIsAggregated && contactIsAggregated) {
              consolidatedHistory = {
                id: 'consolidatedhistory',
                groupid: 'orders',
                name: Utils.translate('Aggregated Purchase History'),
                index: 9,
                url: 'consolidated'
              };

              consolidatedReturns = {
                id: 'consolidatedreturns',
                groupid: 'orders',
                name: Utils.translate('Aggregated Returns History'),
                index: 10,
                url: 'consolidated-returns'
              };

              myaccountmenu.addGroupEntry(consolidatedHistory);
              myaccountmenu.addGroupEntry(consolidatedReturns);
            }
          }
          promise.resolve();
        });
        return promise;
      });
    }
  };
});
